<template>
  <TagSelector
    :multiple="multiple"
    :items="tags"
    :value="value"
    @input="$emit('input', $event)"
    itemText="title"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: Boolean,
  },
  data() {
    return {
      tags: [],
    };
  },
  created() {
    this.setPages();
  },
  methods: {
    async setPages() {
      const { data } = await this.$api.BlogTag.get();
      this.tags = data;
    },
  },
};
</script>

<style></style>
